var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoRecordAll = function SvgIcoRecordAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    fill: "none",
    viewBox: "0 0 22 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M1.833 9c0 3.195 1.258 6.096 3.304 8.236A9.17 9.17 0 0 1 0 9 9.17 9.17 0 0 1 5.138.764 11.88 11.88 0 0 0 1.833 9m18.334 0c0 3.195-1.258 6.096-3.305 8.236A9.17 9.17 0 0 0 22 9 9.17 9.17 0 0 0 16.863.764 11.88 11.88 0 0 1 20.167 9M19 9A8 8 0 1 1 3 9a8 8 0 0 1 16 0m-7.904-4H8v8h1.763V9.802h.87L12.305 13h2.113l-2.034-3.379q.848-.158 1.288-.745.441-.6.441-1.447 0-.7-.249-1.163a1.86 1.86 0 0 0-.655-.746 2.6 2.6 0 0 0-.96-.396A5 5 0 0 0 11.096 5m-.294 3.31h-1.04V6.493h1.153q.237 0 .486.033.25.034.44.136.193.09.317.271.125.18.125.486 0 .328-.147.509a.83.83 0 0 1-.35.27 1.9 1.9 0 0 1-.487.102q-.259.012-.497.012",
    clipRule: "evenodd"
  })));
};
export default SvgIcoRecordAll;